import { render, staticRenderFns } from "./Actividades.vue?vue&type=template&id=3aa893a6&"
import script from "./Actividades.vue?vue&type=script&lang=js&"
export * from "./Actividades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports